































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'FForm'
})
class FForm extends Vue {
  @Prop() readonly action!: string
  private isFormValid = false
}

export default FForm
